module.exports = __webpack_public_path__ + "img/circle-quarter.3ef0e1fa.svg";